import React, { createContext, useEffect, useMemo, useState } from "react";
import CallResponse from "./CallResponse";
import DatePicker from 'react-datepicker';
import { CloseButton, Form, Offcanvas, Spinner } from "react-bootstrap";
import { Tabs, Button } from 'antd';
import { useCustomer, useDoctorSlot, useTicketHistory } from "../actionables/store";
import Comments from "./Comments";
import useDoctorDashboardStore from "modules/all_doctor_dashboard/store";
import { useParams } from "react-router-dom";
import useAssignedStore from "modules/my_tickets/assigned_tickets/store";
import { useToast } from "modules/navbar/top/store/toasterStore";
import MiddleWarePrescription from "./MiddleWarePrescription";
import moment from "moment";
import { createMeidcalEscalationTicket } from "modules/navbar/top/store";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MedOralMinox from "./MedOralMinox";
import _ from 'lodash';
import { Descriptions, Space, Alert, Switch, Input, Typography } from 'antd';
import { useConsultDoctor } from 'modules/dashboards/actionables/store';
import Tick from "assets/svgs/tick";
import { categoryMap, subCategoryMap } from 'modules/navbar/top/helper';
import secureLocalStorage from "react-secure-storage";
import { currentUser } from "modules/utilities/utility";
import { latestTicketByCategory } from "functionCall";
import { CATEGORY, TICKET_STATUS_CODE } from 'modules/my_tickets/data';
import { useDoctorFollowUp } from 'pages/store';
import { useTicketSlots } from 'modules/CreateTicket/store';
import Reschedule from '../actionables/Reschedule';
import SoftBadge from "modules/common/SoftBadge";
import { DISP_FLAG } from "../../utilities/utility";
const { MEDICAL_ESCALATIONS, CUSTOMER_COMPLAINTS, PRODUCT_REACTION_ISSUE, DOCTOR_FOLLOWUP } = CATEGORY;
const { PENDING, CLOSED } = TICKET_STATUS_CODE;
export const prescriptionContext = createContext(null);
const { Text } = Typography;
const { TextArea } = Input;

function InterventionBooking({ caseId, bookingId, orders, callType, syntheticId, setSlotBookingPayload, engTicketId, customer}) {

  const { fetchTicketHistory, ticketData, isLoading } = useTicketHistory();
  const { fetchMeidcalCreateTicket } = createMeidcalEscalationTicket();
  const { markDoctorSlotFinished, markSlotLoading, markPaidDoctorSlotFinished } = useDoctorSlot();
  const { handleFollowUpSubmit, doctorFollowUpSlot } = useDoctorFollowUp();

  const { updateAssignedData, updateLoading } = useAssignedStore();
  const { customerData } = useCustomer();
  const { setToaster } = useToast();
  const { id } = useParams();

  const [value, setValue] = useState({ "need_oral-minoxidil": null, "minoxidil-consent": null, "baseline-bp": null, "can_be-prescribed": null, "oral_minox_need": null, reason: [] });
  const [formData, setFormData] = useState({ callResponse: null, comments: null });
  const [slotMap, setSlotMap] = useState([])
  const [prescriptionChecked, setPrescriptionChecked] = useState(false);
  const [selectedSlot, setSelectedSlot] = useState(false);

  const { ticketSlots, fetchTicketSlotData } = useTicketSlots();
  const [selectedSubcategory, setSelectedSubcategory] = useState();

  const { fetchMedicalSlotData, allSlotData } = useConsultDoctor();
  const [prescFileName, setPrescFileName] = useState(false);
  const [followUpCheck, setFollowUpCheck] = useState(false);
  const [doctorfollowUpCheck, setDoctorFollowUpCheck] = useState(false);
  const [selectedDate, setSelectedDate] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState();
  const [month, setMonth] = useState(null);
  const [show, setShow] = useState(false);
  const [doctorCallAttempt, setDoctorCallAttempt] = useState([]);
  const [orderId, setOrderId] = useState();
  const [CSATComment, setCSATComment] = useState('');
  const [ticketId, setTicketId] = useState();
  const [ticket, setTicket] = useState();
  const [engTicket, setEngTicket] = useState();
  const excludedCallTypes = ["499 Call", "Paid Call", "Direct Call", "Offline Appointment"];
  const prescriptionAccess = ["Paid Call", "Offline Appointment"];
  const [cxSatisfaction, setCxSatisfaction] = useState(true);

  useEffect(() => { if (id) { fetchTicketHistory(id); } }, [id]);
  useEffect(() => { setFormData({ callResponse: null, comments: null, }); }, [customerData]);
  useEffect(() => {
    const medicalEscalationTicket = ticketData
      .filter((ticket) => (((ticket.category === MEDICAL_ESCALATIONS || ticket.category === CUSTOMER_COMPLAINTS) && ticket.status === "Pending")
        || (ticket.sub_category === DOCTOR_FOLLOWUP && ticket.status === "Open" )) && ticket._id === engTicketId)
      .reverse()
    const engagementTicket = ticketData.filter((ticket) => (ticket._id === engTicketId));
    setEngTicket(engagementTicket);
    const hasTicketData = medicalEscalationTicket.length > 0 && !isLoading;
    const _ticket = hasTicketData ? medicalEscalationTicket[0] : null;
    setTicket(_ticket);
    setDoctorCallAttempt(_.get(_ticket, 'doctor_call_attempt', 0));

    const medicalTicketOrders = orders?.filter((item) => (item?.order_display_id == _.get(ticket, ['source_meta', 'order_display_id'], '')));
    setOrderId(medicalTicketOrders);
    setDoctorFollowUpCheck(_ticket ? _ticket.sub_category === DOCTOR_FOLLOWUP : false); 

    setTicketId(_.get(_ticket, '_id', ""));
  }, [ticketData, engTicketId]);

  const oralCategory = [MEDICAL_ESCALATIONS];
  const clinicUser = ["clinic_doctor"];
  const monthData = month;


  const formRow = "d-flex gap-3";
  const buttonStyle = "border rounded-2 mb-0 p-2 cursor-pointer option-hover flex-1 text-center";
  const selected = "border rounded-2 mb-0 p-2 cursor-pointer bg-primary text-white flex-1 text-center";

  let ticketTemplate = {
    action_taker: "",
    address: {},
    author_id: "",
    case_id: "",
    category: "",
    comment: {
      commented_by: "",
      description: "",
      type: "",
    },
    current_assignment: "",
    due_date: "",
    is_internal: false,
    priority: "",
    products: [],
    provider: null,
    provider_meta: {
      descriptionValue: "",
      due_date: "",
      subject: "",
    },
    remark: "",
    source: "crm",
    source_meta: {
      order_details: "",
      order_display_id: "",
      order_id: "",
      title: "",
    },
    sub_category: "",
    waba: false,
  };
  const handleChange = value => setCSATComment(value);
  const debouncedChangeHandler = useMemo(() => _.debounce(handleChange, 300), []);
  let selectedText = `Customer Name: ${_.get(orderId, [0, 'order_meta', 'customer', 'first_name'], '')} Order ID: ${_.get(ticket, ['source_meta', 'order_display_id'], '')}`;

  const handleShow = () => setShow(true);

  const handleSlotDisplay = async (id, selectedDate) => {
   await handleFollowUpSubmit(id, selectedDate);
  }

  useEffect(()=>{
if(doctorFollowUpSlot && doctorFollowUpSlot.length){
  getSlotsMap(doctorFollowUpSlot);
}
  }, [doctorFollowUpSlot, selectedSlot])
  const updateAnsweredTicket = () => {
    const currentAssignment = _.get(ticket, ['current_assignment', 'user_id'], '');
    const medicalAgent = _.get(ticket, 'medical_agent', currentAssignment);
    const action_taker = secureLocalStorage.getItem("id");
    const payloadEditTicket = {
      comment: {
        type: MEDICAL_ESCALATIONS,
        commented_by: action_taker,
        description: `${formData?.comments}${cxSatisfaction ? '' : `
        Doctor CSAT: ${CSATComment}`}`,
      },
      current_assignment: cxSatisfaction ? action_taker : medicalAgent,
      action_taker: action_taker,
      status_code: cxSatisfaction ? CLOSED : PENDING,
      prescriptionStatus: prescFileName,
      prescriptionName: prescFileName,
      doctor_call_attempt: doctorCallAttempt + 1,
      isDoctorFollowup: followUpCheck,
      case_id: customerData?.id,
      slots: selectedSlot,
      slot_time: selectedSlot.slotTime,
      is_follow_up: followUpCheck
    };
    console.log({ticketId});
    if (ticketId !== undefined) {
      console.log('implementing updateAssignedData');
      updateAssignedData(ticketId, payloadEditTicket, setToaster);
    }
  };
  const onSlotSelection = (slot) => {
    if(!_.isEmpty(slot)) {
      setSelectedSlot(slot)
    };
    const slotData = {
        slotTime: slot.slotTime,
        availableSlots: slot.slots,
        isRescheduling: false,
        orderRelated: false,
        fromCrm: true,
    }
    if(selectedCategory === MEDICAL_ESCALATIONS){
        slotData.isMedicalEscalation = true;
        slotData.slotId = slot.id;
        slotData.sessionId = sessionIdforSlot
    }
    setSlotBookingPayload(prevPayload => ({
        ...prevPayload,
        ...slotData
    }));
};

  const updateUnansweredTicket = () => {
    const action_taker = secureLocalStorage.getItem("id");
    const payloadEditTicket = {
      comment: {
        type: MEDICAL_ESCALATIONS,
        commented_by: action_taker,
        description: `Unanswered call ${doctorCallAttempt + 1}`,
      },
      action_taker: action_taker,
      doctor_call_attempt: doctorCallAttempt + 1
    };
    console.log({ticketId});
    if (ticketId !== undefined) {
      updateAssignedData(ticketId, payloadEditTicket, setToaster);
    }
  };

  useEffect(() => {
    if (selectedCategory === MEDICAL_ESCALATIONS) {
        getSlotsMap(allSlotData);
      
    };
  }, [allSlotData, ticketSlots, selectedSlot, selectedSubcategory]) 


  const getSlotsMap = (slotData) => {
    if (_.isArray(slotData) && !_.isEmpty(slotData)) {
      // Filter slots before 8 PM and organize them by date
      const slots = slotData.filter(slot => new Date(slot.slotTime).getHours() <= 21)
        .reduce((acc, slot) => {
          const formattedDate = moment(slot.slotTime).format('DD-MM-YYYY');
          if (!acc[formattedDate]) {
            acc[formattedDate] = [];
          }
          acc[formattedDate].push({ slotLabel: moment(slot.slotTime.toString()).format('hh:mm A'), ...slot });
          return acc;
        }, {});

      // Flatten the data into a format suitable for Ant Design Tabs
      const slotMap = Object.entries(slots).map(([date, slots], index) => {
        const tabContent = slots.map((slot, slotIndex) => {
          return selectedSlot.slotTime === slot.slotTime ?
            <Button className='m-1' type='primary'>{slot.slotLabel}</Button> :
            <Button className='m-1'
              disabled={slot.count === 0}
              onClick={() => {
                onSlotSelection(slot)
              }} >
              {slot.slotLabel}
            </Button>
        });

              return {
                label: date,
                key: index + 1,
                children: <div>{tabContent}</div>
              };
          });

          setSlotMap(slotMap);
     // }
  }
};


  // const setTicketData = () => {
  //   ticketTemplate = {
  //     ...ticketTemplate,
  //     action_taker: secureLocalStorage.getItem("id"),
  //     address: {
  //       city: _.get(orderId, ['0', 'order_meta','customer', 'default_address', 'city'],"-"),
  //       locality: _.get(orderId, ['0', 'order_meta','shipping_address', 'address1'],"-"),
  //       landmark: _.get(orderId, ['0', 'order_meta','shipping_address', 'address2'],"-"),
  //       state: _.get(orderId, ['0', 'order_meta','shipping_address', 'province'],"-"),
  //       pincode: _.get(orderId, ['0', 'order_meta','shipping_address', 'zip'],"-"),
  //     },
  //     author_id: secureLocalStorage.getItem("id"),
  //     priority: "4",
  //     case_id: customerData?.id,
  //     category: MEDICAL_ESCALATIONS,
  //     comment: {
  //       commented_by: secureLocalStorage.getItem("id"),
  //       description: CSATComment,
  //       type: MEDICAL_ESCALATIONS,
  //     },
  //     due_date: selectedDate.toISOString(),
  //     provider_meta: {
  //       descriptionValue: formData?.comments,
  //       due_date: selectedDate,
  //       subject: `${_.get(ticket, ['source_meta', 'order_display_id'], '')} : ${_.get(orderId, [0, 'order_meta', 'customer', 'first_name'], '')} : ${MEDICAL_ESCALATIONS} -> ${"follow_up"}`,
  //     },
  //     source_meta: {
  //       title: "create_ticket",
  //       order_details: selectedText,
  //       order_display_id: _.get(ticket, ['source_meta', 'order_display_id'], ''),
  //       order_id: orderId?.[0]?.id,
  //     },
  //     sub_category: "follow_up",
  //     waba: false,
  //   };
  // };

  // const handleCreateTicket = () => {
  //   setTicketData();
  //   fetchMeidcalCreateTicket(ticketTemplate, toast, false);
  // };

  const filteredObject = Object.entries(value).reduce((acc, [key, val]) => (val && val.length ? { ...acc, [key]: val } : acc), {});

  return (
    <div>
            <Button type='primary' className="flex-1" onClick={() => handleShow()}>
              <Tick />
            </Button>
      <Offcanvas
        show={show}
        placement={"end"}
        style={{ width: DISP_FLAG ?"77%":"40%" }}
        onHide={() => setShow(false)}
      >
        <Offcanvas.Header CloseButton>
        <Space direction="horizontal">
        <Offcanvas.Title >Add Feedback</Offcanvas.Title>
            {(engTicket && engTicket[0]?.status === "Closed" && !excludedCallTypes.includes(callType))?
             (<Alert  message="Ticket is already closed. Can not create the Prescription" type="error" showIcon />) : null}
        </Space>
          <CloseButton
            className="btn btn-circle btn-sm transition-base p-0"
            onClick={() => setShow(false)}
          />
        </Offcanvas.Header>
        <Offcanvas.Body
          style={{ maxHeight: "90vh", overflowY: "scroll" }}
          className="scrollable-container"
        >
          <div className="d-flex gap-3 flex-row">
            <div>
            {DISP_FLAG &&<DispositionComponent customer={customer} />}
            </div>
            <div>
            {!excludedCallTypes.includes(callType) && <Descriptions title="Ticket Details" bordered layout='vertical'>
                <Descriptions.Item span={2} label="Category">{categoryMap[ticket?.category] || ticket?.category}</Descriptions.Item>
                <Descriptions.Item span={2} label="Sub Category"> {subCategoryMap[ticket?.sub_category] || ticket?.sub_category}</Descriptions.Item>
                <Descriptions.Item span={3} label="Comments">{ticket?.comments?.[0]?.description}</Descriptions.Item>
              </Descriptions>
              }
              <CallResponse
                formData={formData}
                buttonStyle={buttonStyle}
                selected={selected}
                setFormData={setFormData}
                formRow={formRow}
              />
              {formData?.callResponse === "answered" && (
                <div className="mt-3">
                  {prescriptionChecked ? (
                    <div className="border border-2 p-1 rounded shadow mb-1">
                      <div>
                        <span className="fw-bold">
                          Category:
                          <SoftBadge pill bg="info" className="me-2 ms-2">
                            <span style={{ fontSize: "12px" }}>
                              {ticket?.category
                                .replaceAll("_", " ")
                                .toUpperCase()}
                            </span>
                          </SoftBadge>
                        </span>
                        <span
                          className="fw-bold"
                          style={{ marginLeft: "10px" }}
                        >
                          Sub Category:
                          <SoftBadge pill bg="info" className="me-2 ms-2">
                            <span style={{ fontSize: "12px" }}>
                              {ticket?.sub_category
                                .replaceAll("_", " ")
                                .toUpperCase()}
                            </span>
                          </SoftBadge>
                        </span>
                      </div>
                      <div>
                        <div>
                          <span className="fw-bold"> Comments </span>:{" "}
                          {ticket?.comments?.[0]?.description}
                        </div>
                      </div>
                    </div>
                  ) : null}
                  <Comments
                    comment={formData?.comments}
                    setFormData={setFormData}
                    length={formData?.comments?.length}
                  />

                  {!excludedCallTypes.includes(callType) && callType !== "Follow Up Intervention" && <Form.Check
                    type="checkbox"
                    id="checkedTickets"
                    label="Create ticket for Follow Up Call"
                    className="mt-3"
                    value={followUpCheck}
                    onClick={(event) => setFollowUpCheck(event.target.checked)}
                  />}
                  {followUpCheck ? (
                  <div>
                    <div className="d-flex align-items-center">
                      <DatePicker
                        selected={selectedDate}
                        onChange={(date) => setSelectedDate(date)}
                        placeholderText="Select Date"
                        dateFormat="dd-MM-yyyy"
                        minDate={moment().toDate()}
                        maxDate={moment().add(3, 'months').toDate()}
                        className= "me-2"
                      />
                      <Button
                        type="primary"
                        onClick={() => handleSlotDisplay(secureLocalStorage.getItem("id"), selectedDate)}
                      >
                        Submit
                      </Button>
                      </div>
                      <div>
                      {selectedDate ? (<Tabs defaultActiveKey='1' type='card' size={'middle'} items={slotMap} /> ) : null}     
                      </div> 
                        </div>
                  ) : null}


                  {callType !== "Follow Up Intervention" && oralCategory.includes(ticket?.category) ? (
                    <MedOralMinox
                      value={value}
                      setValue={setValue}
                      month={month}
                      setMonth={setMonth}
                    />
                  ) : null}
                    {!prescriptionAccess.includes(callType) && <Form.Check
                    type="checkbox"
                    id="checkedCheckbox"
                    label="Additional Prescription Writing"
                    className="mt-3"
                    value={prescriptionChecked}
                    onClick={(event) =>
                      setPrescriptionChecked(event.target.checked)
                    }
                  />}
                  {(prescriptionChecked || clinicUser.includes(currentUser)) ? (
                    <prescriptionContext.Provider value={monthData}>
                      <MiddleWarePrescription
                        caseId={caseId}
                        setPrescriptionChecked={setPrescriptionChecked}
                        setPrescFileName={setPrescFileName}
                        callType={callType}
                        syntheticId={syntheticId}
                        gender={_.get(customerData, ['user', 'gender'], null) == 'M' ? "male": "female"}
                      />
                    </prescriptionContext.Provider>
                  ) : null}
                  <div className='d-flex justify-content-between'>
                    <Text>Customer Satisfied? </Text>
                    <Switch value={cxSatisfaction} onChange={(value) => {
                        setCxSatisfaction(value);
                        if(value) ticketTemplate.comment.description = PRODUCT_REACTION_ISSUE
                        else{setCSATComment('')}
                      }} />
                  </div>
                  {!cxSatisfaction && <div className='my-2'>
                    <TextArea rows={4} placeholder="Please mention the reason" minLength={6} onChange={(event)=>{debouncedChangeHandler(event.target.value)}}/>
                  </div>}
                  <Button
                    disabled={ updateLoading || ((formData.comments ? !(formData.comments.length > 5) : true) || (!cxSatisfaction ? CSATComment.length < 5 : false)) || ((followUpCheck && !selectedSlot) || (followUpCheck && !selectedDate))}
                    onClick={() => {
                      if(callType == "Paid Call"){ markPaidDoctorSlotFinished(bookingId, { bookingId, comment: formData.comments, unanswered: false, interventionResponses: filteredObject }, toast);}
                      else{ markDoctorSlotFinished(bookingId, { bookingId, comment: formData.comments, unanswered: false, interventionResponses: filteredObject, isFollowUp: doctorfollowUpCheck}, toast);}
                      if (!excludedCallTypes.includes(callType)) { updateAnsweredTicket() }
                      // if (followUpCheck) { handleCreateTicket() }
                    }}
                    className="w-100 mt-4"
                    variant="primary"
                  >
                    {markSlotLoading ? <div className="d-flex gap-2 align-items-center justify-content-center"><Spinner size="sm" /> Disposing Call</div> : <div>Save Disposition</div>}
                  </Button>
                </div>
              )}
              {formData.callResponse === "unanswered" && (
                <Button
                  onClick={() => {
                    if(callType == "Paid Call") { markPaidDoctorSlotFinished(bookingId, { bookingId, comment: "unanswered", unanswered: true }, toast);}
                    else{ markDoctorSlotFinished(bookingId, { bookingId, comment: "unanswered", unanswered: true, isFollowUp: doctorfollowUpCheck}, toast);}
                    if(!excludedCallTypes.includes(callType)) {updateUnansweredTicket();}
                  }}
                  className="w-100 mt-4"
                  variant="primary"
                >
                  {markSlotLoading ? <div className="d-flex gap-2 align-items-center justify-content-center"><Spinner />Disposing Call</div> : <div>Save Disposition</div>}
                </Button>
              )}
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
}

export default InterventionBooking;